import { Box, BoxProps, Td as CTd } from '@chakra-ui/react';
import React from 'react';

export const Td = ({
  children,
  isAvatar,
  sx,
  ...props
}: BoxProps & { isAvatar?: boolean }) => (
  <CTd
    as={Box}
    sx={{
      columnSpan: 2,
      display: 'table-cell',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      verticalAlign: 'middle',
      fontWeight: 400,
      fontSize: 'sm',
      letterSpacing: '0.5px',
      padding: '0 12px',
      border: 'none',
      lineHeight: 'normal',
      color: 'M.70',
      height: '48px',
      ...(isAvatar ? { padding: 0, maxWidth: '40px', width: '40px' } : {}),
      '&.gap': {
        px: 0,
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </CTd>
);
